<template>
  <div class="layout-header">
    <span class="header-left">
      <img :src="require('@/assets/img/logo/logo.png')" />
      <el-divider direction="vertical"></el-divider>
      <span>SaaS电商ERP管理中心</span>
    </span>
    <div class="header-right">
      <el-menu background-color="#0075E3" text-color="#fff" active-text-color="#fff" mode="horizontal">
        <el-submenu popper-append-to-body index="user">
          <template slot="title">
            <el-avatar
              size="large"
              src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
            <span>{{ loginData.UserName }}，{{ cnTime }}</span>
          </template>
          <el-menu-item index="password" @click="editPassword"><i class="ri-lock-2-line"></i>修改密码</el-menu-item>
          <el-menu-item index="logout" @click="logout"><i class="ri-logout-circle-line"></i>退出登录</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>

    <password-edit ref="editPassword" v-if="dialogVisible"></password-edit>
  </div>
</template>

<script>
import { getUserInfo } from '@/api/user';
import { getCnTime } from '@/utils/tool';
import PasswordEdit from '@/views/components/layout/PasswordEdit.vue';

export default {
  name: 'LayoutHeader',
  data() {
    return {
      cnTime: '',
      loginData: {},
      dialogVisible: false,
    };
  },
  created() {
    this.$nextTick(async () => {
      this.cnTime = getCnTime();
      const { data } = await getUserInfo();
      this.loginData = { ...data };
    });
  },
  methods: {
    logout() {
      this.$baseConfirm('您确定要退出' + this.$baseTitle + '管理中心吗?', null, async () => {
        await this.$store.dispatch('tabsBar/delAllRoutes');
        await this.$store.dispatch('user/logout');
        this.$router.push('/login');
      });
    },
    editPassword() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.editPassword.init();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-header {
  width: 100vw;
  background: $base-color-blue;
  height: $base-header-height;
  line-height: $base-header-height;
  position: relative;
  color: rgba(255, 255, 255, 1);
  .header-left {
    font-size: 20px;
    font-weight: bold;
    img {
      margin-left: 20px;
      width: 172px;
      height: 40px;
      vertical-align: middle;
      object-fit: contain;
    }
    .el-divider {
      margin: 0 19px;
      height: 26px;
    }
  }
  .header-right {
    position: absolute;
    display: flex;
    top: 0;
    right: 11px;
    font-size: 14px;
    font-weight: 400;
    height: 100%;
  }

  .el-submenu {
    ::v-deep {
      .el-submenu__title {
        height: 100%;
        font-weight: 400;
        border-bottom: 0;
        background-color: #0075e3 !important;
      }

      i {
        color: #fff;
        font-size: 15px;
      }
    }
  }
  ::v-deep {
    .el-avatar {
      margin-right: 12px;
    }
    .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
      border-bottom: 0 !important;
      color: #0075e3;
    }
    .el-menu.el-menu--horizontal {
      .el-menu__item.is-active {
        border-bottom: 0 !important;
      }
      border-bottom: 0 !important;
    }
    .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
      background: #0075e3 !important;
      color: #fff !important;
    }
  }
}
.el-menu {
  min-width: 160px !important;
  margin-top: 1px !important;
}
.el-menu-item {
  color: #fff !important;
  margin-right: 5px !important;
  font-size: 15px !important;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  gap: 10px;
  height: 46px !important;
  line-height: 46px !important;
}
.el-menu-item i {
  color: #fff !important;
}
.el-menu--popup-bottom-start {
  margin-top: 7px !important;
}
</style>
